export const getClassesOcupacao = (state) => state.classesOcupacao.lista
export const getIsCarregandoListaClassesOcupacao =
  (state) => state.classesOcupacao.isCarregandoLista
export const getIsSavingClassesOcupacao = (state) => state.classesOcupacao.isSaving
export const getIsUpdatingClassesOcupacao = (state) => state.classesOcupacao.isUpdate
export const getTotalClassesOcupacao = (state) => state.classesOcupacao.total
